// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add to Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

const skin_concern_collections = {
  "acne":"https://www.aboutface.co.nz/collections/acne",
  "aging":"https://www.aboutface.co.nz/collections/aging-fine-lines-wrinkles",
  "Dryness_Dehydration":"https://www.aboutface.co.nz/collections/dryness-dehydration",
  "Redness_Sensitivity":"https://www.aboutface.co.nz/collections/redness-sensitivity",
  "Enlarged_Pores":"https://www.aboutface.co.nz/collections/enlarged-pores-texture",
  "Dark_Spots_Pigmentation":"https://www.aboutface.co.nz/collections/dark-spots-pigmentation",
  "Dullness_Lack_Glow":"https://www.aboutface.co.nz/collections/dullness-lack-of-glow",
  "loss_of_firmness":"https://www.aboutface.co.nz/collections/lack-of-firmness"
}

// Add default image url here
const tangent_default_selfie_image_url="https://www.aboutface.co.nz/cdn/shop/files/Screenshot_2025-04-16_at_3.25.05_PM_06a56603-e3dd-43fd-9545-8398d355e663.png?v=1744773941&width=3000";
const tagImageMap = {
  "Dark_Spots_Pigmentation":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Screenshot_2025-04-16_at_3.25.05_PM_06a56603-e3dd-43fd-9545-8398d355e663.png?v=1744773941",
  "acne":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/56.webp?v=1745872189",
  "aging":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Home_care_2.jpg?v=1741236452",
  "Dryness_Dehydration":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Screenshot_2025-05-02_at_2.37.13_PM.png?v=1746153439",
  "Redness_Sensitivity":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Screenshot_2025-04-16_at_3.25.05_PM_06a56603-e3dd-43fd-9545-8398d355e663.png?v=1744773941",
  "Enlarged_Pores":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Screenshot_2025-04-29_at_9.42.33_AM.png?v=1745876722",
  "Dullness_Lack_Glow":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/Screenshot_2025-04-29_at_9.42.33_AM.png?v=1745876722",
  "Lack_of_Firmness":"https://cdn.shopify.com/s/files/1/0466/1975/4659/files/About_Face_2216_1_1_1_1.jpg?v=1777358622"
}
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", (event) => {
        onLoadFunction();
    });
} else {
    onLoadFunction();
}

function onLoadFunction(){
  const tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id); 
}

function getClientResponseId(){
  // Current Page Load URL
  let tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 
        document.getElementById('tangent-banner-cart').innerHTML = getPromoBannerHTML(response.tags);       
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
            
          const variantId = extractShopifyNumericId(variant.id);
          // Track selected product variant
          tangent_selected_product_map[product.id] = variantId;
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections, variantId);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;

          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractShopifyNumericId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? match[0] : null;
}


function getProductHTML(product, index, variant, section, sections, variantId) {
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  let variantTitle= variant.title;
  if(variantTitle=="Default Title"){
    variantTitle="";
  }
  // Product View HTML using template literals
  const product_html = `
    <div class="tangent-product-data-container">
      <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
      <div class="tangent-title-and-description">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
        </a>
        ${getProductDescription(product)}
      </div>
      <div id="${section}_variant_${index}"></div>
      ${getButtonHTML(product, variant, section, sections, variant_product_url, variantId)}
    </div>
  `;
  
  return product_html;
}

function getProductDescription(product){
  const description = product?.tangent_quiz_product_description?.value?.trim() || '';
  if (description !== '') {
    return `<p class="tangent_product_description">${description}</p>`;
  }
  return '';
}

function getButtonHTML( product, variant, section, sections, url, variantId){
  let buttonClass="";
  let buttonText = default_addToCartText;
  
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    buttonText = out_of_stock_text;
    buttonClass ="disable-button";
  }
  if(section==='section_additional_treatment'){
    buttonText = isProductInDraftState(product) ? 'In Draft' : default_addToCartText ;
    return `
      <button class="tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${buttonClass}" ><a id="${variantId}" href='${url}' target='_blank'>
        ${buttonText}
      </a></button>
    `;
  }
  else{
return `
    <button aria-label="${buttonText}" id="${variantId}" type="submit" name="add" class="js-add-to-cart product-form__submit button button--full-width button--secondary tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${buttonClass}" aria-haspopup="dialog">
      <span>${buttonText}</span>
      <div class="loading-overlay__spinner hidden">
        <div class="lds-ring" aria-hidden="true">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </button>
    `;
  }
}

function isProductInDraftState(product){
  if(product.status.toLowerCase() === "draft") return true;
  return false;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById("tangent-add-all-cart-button").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

function addToCart(element){ 
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;

  let formData = {
    items: [{
      id: Number(element.id),
      quantity: 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(async (response) => {
    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 

    element.dispatchEvent(
      new CustomEvent("cart-drawer:refresh", {
        detail: { response: response },
        bubbles: true,
        composed: true
      })
    );
    return data;
  })
  .catch((error) => {
    if (error && error.status) {
      const message = error.message || "Something went wrong";

      element.innerHTML = "Add to Cart";
      element.classList.remove("added-to-cart-style");

      showCartError(element, message);
    } 

    element.dispatchEvent(
      new CustomEvent("cart-drawer:refresh", {
        detail: { response: error },
        bubbles: true,
        composed: true
      })
    );
  });
}

function showCartError(targetElement, message) {
  if (!targetElement) return;

  const parent = targetElement.parentNode;

  // Remove existing message
  const existing = parent.querySelector('.tangent-cart-error-msg');
  if (existing) existing.remove();

  const el = document.createElement('p');
  el.textContent = message;
  el.className = 'tangent-cart-error-msg';

  targetElement.insertAdjacentElement('afterend', el);

  // Store timeout on element to prevent multiple timers
  if (targetElement._errorTimeout) {
    clearTimeout(targetElement._errorTimeout);
  }

  targetElement._errorTimeout = setTimeout(() => {
    const msg = parent.querySelector('.tangent-cart-error-msg');
    if (msg) msg.remove();
  }, 4000);
}

function addResponseTextBelow(element, response){
  const textEl = document.createElement('p');
  textEl.textContent = response.message;
  element.insertAdjacentElement('afterend', textEl);
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_to_cart_p_tag;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));

      if(section_name!='section_additional_treatment'){
        // Creating add all to cart button for the section    
        // section_container.appendChild(createSectionAddAllToCart(section_name));
        // section_container.appendChild(createCustomText(section_name));
      }

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

function getPromoBannerHTML(tags) {
  const collectioUrl = getCollectionUrlFromTags(tags);
  return `
    <div class="tangent-promo-banner">
      <div class="promo-content">
        <h1>
          Add TWO products<br>
          to your cart and get<br>
          <span>15% OFF!</span>
        </h1>
        <a id="tangent-add-all-cart-button" class="promo-btn" href="${collectioUrl}">SHOP NOW</a>
      </div>
      <div id="tangent-banner-image-section">
        <img src="https://www.aboutface.co.nz/cdn/shop/files/Heading.jpg"/>
      </div>
    </div>
  `;
}

function getCollectionUrlFromTags(tags) {
  for (const key in skin_concern_collections) {
    if (tags.includes(key)) {
      return skin_concern_collections[key];
    }
  }
  return 'https://www.aboutface.co.nz/collections'; // if no match found
}

function createCustomText(section_name){
  const customText = document.createElement("p");
  customText.id = section_name+"_custom_text";
  customText.classList.add("section_custom_text");
  customText.innerHTML = `Buy 2, get 15% off`
  return customText;
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }// To Add to top of the page container
            else if(section_name == "section_additional_treatment"){
              var section_additional_treatment = document.querySelector("#tangent_treatment_section");
              section_container.classList.remove('tabcontent');   
              section_additional_treatment.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
              document.querySelector('#tangent_selfie_image').src = getAnyCustomImageBasedOnTags(response.tags);
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

function getAnyCustomImageBasedOnTags(tags){
  for (const tag of tags) {
    console.log("tags ",tag);
    if (tagImageMap.hasOwnProperty(tag)) {
      console.log("tag found",tag);
      return tagImageMap[tag];
    }
  }
  return tangent_default_selfie_image_url; // Return a default image URL if no match  
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
